import { render, staticRenderFns } from "./ClassPreview.vue?vue&type=template&id=bee1fa86&scoped=true"
import script from "./ClassPreview.vue?vue&type=script&lang=js"
export * from "./ClassPreview.vue?vue&type=script&lang=js"
import style0 from "./ClassPreview.vue?vue&type=style&index=0&id=bee1fa86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bee1fa86",
  null
  
)

export default component.exports